import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
    
  const userType = localStorage.getItem("userType");
  const email = localStorage.getItem("email");
  console.log(email,userType);
  
  if (!email) return <Navigate to="/admin/login" />;
  if (userType !== "0"&& userType !== "1") return <Navigate to="/admin/login" />;

  return children;
};

export default AdminRoute;
